import { Input, Select, SelectItem } from "@heroui/react";
import { Plus } from "@phosphor-icons/react";
import ButtonNew from "components/buttonNew/buttonNew";
import { useState } from "react";
import {
  ProcedureDateType,
  PROCEDURE_DATE_TYPE_LABELS,
} from "shared/types/legal-procedure";

interface ProcedureDateFormProps {
  onSubmit: (data: {
    type: ProcedureDateType;
    date: string;
    remarks?: string;
  }) => Promise<void>;
  onCancel: () => void;
  isSaving: boolean;
}

const DATE_TYPE_OPTIONS = Object.entries(PROCEDURE_DATE_TYPE_LABELS).map(
  ([key, label]) => ({ key, label })
);

export const ProcedureDateForm = ({
  onSubmit,
  onCancel,
  isSaving,
}: ProcedureDateFormProps) => {
  const [type, setType] = useState<ProcedureDateType>(
    ProcedureDateType.ZITTING
  );
  const [date, setDate] = useState("");
  const [remarks, setRemarks] = useState("");

  const handleSubmit = async () => {
    if (!date) return;
    await onSubmit({
      type,
      date,
      remarks: remarks || undefined,
    });
  };

  return (
    <div className="border rounded-lg p-3 bg-neutral-50">
      <h5 className="text-sm font-medium mb-2">Nieuwe gebeurtenis / termijn toevoegen</h5>
      <div className="flex flex-col gap-2">
        <div className="grid grid-cols-2 gap-2">
          <Select
            label="Type"
            selectedKeys={[type]}
            onSelectionChange={(keys) => {
              const key = Array.from(keys)[0] as ProcedureDateType;
              if (key) setType(key);
            }}
            size="sm"
          >
            {DATE_TYPE_OPTIONS.map((option) => (
              <SelectItem key={option.key}>{option.label}</SelectItem>
            ))}
          </Select>

          <Input
            label="Datum"
            type="date"
            value={date}
            onValueChange={setDate}
            size="sm"
          />
        </div>

        <Input
          label="Opmerkingen"
          placeholder="Optionele opmerkingen..."
          value={remarks}
          onValueChange={setRemarks}
          size="sm"
        />

        <div className="flex justify-end gap-2">
          <ButtonNew
            variant="secondaryNeutral"
            label="Annuleren"
            onClick={onCancel}
          />
          <ButtonNew
            variant="primaryMoss"
            icon={<Plus size={12} />}
            label={isSaving ? "Opslaan..." : "Toevoegen"}
            onClick={handleSubmit}
            isDisabled={isSaving || !date}
          />
        </div>
      </div>
    </div>
  );
};
